var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlbumCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.album-create{fill:#0978f6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "album-create",
    d: "M463 837V593H219v-35h244V314h35v244h244v35H498v244h-35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumCreate);
export default __webpack_public_path__ + "static/media/album_create.f362cbda01cee435ac22c369688cb822.svg";
export { ForwardRef as ReactComponent };